/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createInventoryTransaction } from '../fn/inventory-transactions/create-inventory-transaction';
import { CreateInventoryTransaction$Params } from '../fn/inventory-transactions/create-inventory-transaction';
import { deleteInventoryTransaction } from '../fn/inventory-transactions/delete-inventory-transaction';
import { DeleteInventoryTransaction$Params } from '../fn/inventory-transactions/delete-inventory-transaction';
import { getInventoryTransaction } from '../fn/inventory-transactions/get-inventory-transaction';
import { GetInventoryTransaction$Params } from '../fn/inventory-transactions/get-inventory-transaction';
import { InventoryTransactionDto } from '../models/inventory-transaction-dto';
import { InventoryTransactionDtoPage } from '../models/inventory-transaction-dto-page';
import { listInventoryTransactions } from '../fn/inventory-transactions/list-inventory-transactions';
import { ListInventoryTransactions$Params } from '../fn/inventory-transactions/list-inventory-transactions';
import { updateInventoryTransaction } from '../fn/inventory-transactions/update-inventory-transaction';
import { UpdateInventoryTransaction$Params } from '../fn/inventory-transactions/update-inventory-transaction';

@Injectable({ providedIn: 'root' })
export class InventoryTransactionsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listInventoryTransactions()` */
  static readonly ListInventoryTransactionsPath = '/v0/inventoryTransactions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInventoryTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryTransactions$Response(params?: ListInventoryTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryTransactionDtoPage>> {
    return listInventoryTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInventoryTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryTransactions(params?: ListInventoryTransactions$Params, context?: HttpContext): Observable<InventoryTransactionDtoPage> {
    return this.listInventoryTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<InventoryTransactionDtoPage>): InventoryTransactionDtoPage => r.body)
    );
  }

  /** Path part for operation `createInventoryTransaction()` */
  static readonly CreateInventoryTransactionPath = '/v0/inventoryTransactions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInventoryTransaction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryTransaction$Response(params: CreateInventoryTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryTransactionDto>> {
    return createInventoryTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInventoryTransaction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryTransaction(params: CreateInventoryTransaction$Params, context?: HttpContext): Observable<InventoryTransactionDto> {
    return this.createInventoryTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<InventoryTransactionDto>): InventoryTransactionDto => r.body)
    );
  }

  /** Path part for operation `getInventoryTransaction()` */
  static readonly GetInventoryTransactionPath = '/v0/inventoryTransactions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventoryTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryTransaction$Response(params: GetInventoryTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryTransactionDto>> {
    return getInventoryTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventoryTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryTransaction(params: GetInventoryTransaction$Params, context?: HttpContext): Observable<InventoryTransactionDto> {
    return this.getInventoryTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<InventoryTransactionDto>): InventoryTransactionDto => r.body)
    );
  }

  /** Path part for operation `updateInventoryTransaction()` */
  static readonly UpdateInventoryTransactionPath = '/v0/inventoryTransactions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventoryTransaction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryTransaction$Response(params: UpdateInventoryTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateInventoryTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInventoryTransaction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryTransaction(params: UpdateInventoryTransaction$Params, context?: HttpContext): Observable<void> {
    return this.updateInventoryTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteInventoryTransaction()` */
  static readonly DeleteInventoryTransactionPath = '/v0/inventoryTransactions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInventoryTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInventoryTransaction$Response(params: DeleteInventoryTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteInventoryTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteInventoryTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInventoryTransaction(params: DeleteInventoryTransaction$Params, context?: HttpContext): Observable<void> {
    return this.deleteInventoryTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
